export { default as AiraFloatingWidget } from './ui/AiraFloatingWidget.vue'
export { default as AiraDevPanel } from './ui/AiraDevPanel.vue'
export { default as AiraRiveFigure } from './ui/AiraRiveFigure.vue'
export { default as AiraBlackoutOverlay } from './ui/AiraBlackoutOverlay.vue'

/** Full-size Aira, served from public/ so the 1.5 MB file stays out of the bundle. */
export const AIRA_FULL_RIVE_SRC = '/rive/aira-full.riv'

/** Looping blob used as the route-change loader. */
export const AIRA_LOADER_RIVE_SRC = '/rive/aira-loader.riv'

/**
 * The newer loading animation (120×120 artboard, `State Machine 1`, no inputs).
 * Used on its own where a block waits on a slow answer, instead of a skeleton.
 */
export const AIRA_LOADING_RIVE_SRC = '/rive/aira-loading-v2.riv'
export { useAira, AIRA_PROPERTY } from './composables/useAira'
export type { AiraPropertyName } from './composables/useAira'
export { useAiraGaze } from './composables/useAiraGaze'
export { useAiraFlyby } from './composables/useAiraFlyby'
export { useAiraTouchGuard } from './composables/useAiraTouchGuard'
export type { AiraTouchGuardOptions } from './composables/useAiraTouchGuard'
export type { AiraFlybyOptions } from './composables/useAiraFlyby'
export { useAiraWidget, useAiraWidgetStore } from './store/useAiraWidgetStore'
export type { AiraController, AiraPropertyValue } from './types'
